import { action, makeObservable, observable } from "mobx";
import AuthStore from "./auth/AuthStore";
import NewAgentStore from "./agents/pages/NewAgentStore";
import EditAgentStore from "./agents/pages/EditAgentStore";
import CustomerStore from "./customer/CustomerStore";
import NewCampaignStore from "./campaigns/NewCampaignStore";
// [DEPRECATED_GRAPHQL] - Para eliminación: ContactStore usa GraphQL queries (getData, getSingleContact, putSingleContact)
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// import ContactStore from "./campaigns/ContactStore";
import UserStore from "./users/UserStore";
import NotificationStore from "./notifications/NotificationStore";
import ProfileStore from "./profile/ProfileStore";
import ViewAgentStore from "./agents/pages/ViewAgentStore";
import NewUserStore from "./users/pages/NewUserStore";
import UnifiedCustomerProfileStore from "./unifiedCustomerProfile/UnifiedCustomerProfile";
import AnnUnifiedCustomerProfileStore from "./annUnifiedCustomerProfile/AnnUnifiedCustomerProfile";
import AgentsTeamsStore from "./agentsTeams/AgentsTeamsStore";
import AgentStore from "./agents/AgentStore";
import AgentTreeStore from "./agentsTeams/AgentTreeStore";
import ConversationsStore from "./conversations/ConversationsStore";
import ViewConversationStore from "./conversations/ViewConversationStore";
import ConversationsActionsStore from "./conversations/ConversationsActionsStore";
import SelectedUserStore from "./users/pages/SelectedUserStore";
import ListUserStore from "./users/pages/ListUserStore";
import ListRoleStore from "./roles/pages/ListRoleStore";
import HistoryAgentStore from "./agents/pages/HistoryAgentStore";
import ListGroupStore from "./groups/ListGroupStore";
import FeatureStore from "./feature/FeatureStore";
import PermissionsSetupStore from "./users/PermissionsSetupStore";
// [DEPRECATED] - BlastCampaignStore replaced by /pages/v2/BlastCampaignPage/context/BlastCampaignContext.jsx
// Uses new REST API (POST /v1/email/send) instead of GraphQL putEmailBlast
// TODO: Remove after verifying new implementation works correctly
import BlastCampaignStore from "./conversations/BlastCampaignStore";
// [DEPRECATED] - ContactSegmentStore replaced by /pages/v2/BlastCampaignPage/context and hooks
// CSV parsing moved to useContactsMapping hook, database contacts use existing contacts service
// TODO: Remove after verifying new implementation works correctly
import ContactSegmentStore from "./conversations/ContactSegmentStore";
import HumanInTheLoopStore from "./humanInTheLoop/HumanInTheLoopStore";
import AssistanceUCPStore from "./unifiedCustomerProfile/AssistanceUCPStore";
import MarketingStore from "./conversations/MarketingStore";
// [DEPRECATED_GRAPHQL] - Para eliminación: AlertStore usa GraphQL queries
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// import AlertStore from "./alerts/AlertsStore";
import DataStore from "./data/DataStore";
import QuestionsStore from "./questions/QuestionsStore";
import NotesStore from "./notes/NotesStore";
import AgentsWidgetHistoryStore from "./agents/pages/AgentsWidgetHistoryStore";
import ConversationListStore from "./conversations/ConversationListStore";
import InstructionsStore from "./playground/InstructionsStore";
import ToolsStore from "./playground/ToolsStore";
import KnowledgeStore from "./playground/knowledgeStore"
import FileStore from "./playground/fileStore"
import PlaygroundConfigStore from "./playground/configStore"
import DocumentStore from "./playground/documentStore"
import PlaygroundAgentStore from "./playground/agentStore"
import BreadcrumbStore from "./breadcrumb/BreadcrumbStore"
import AgentListStore from "./playground/agentListStore"
import VaultStore from "./playground/VaultStore"
import chatDocumentsStoreInstance from "./documents/documentsStore"

// v2 stores
import DrivesStore from "./v2/drives/DrivesStore";
import FoldersStore from "./v2/folders/FoldersStore";
import DocumentsStore from "./v2/documents/DocumentsStore";
import FilesStore from "./v2/files/FilesStore";
import AgentsStore from "./v2/agents/AgentsStore";
import ResourcesStore from "./v2/resources/ResourcesStore";
import UsersStore from "./v2/users/UsersStore";
import WorkspaceStore from "./v2/workspace/WorkspaceStore";
import ChatStore from "./v2/chat/ChatStore";
import DepartmentsStore from "./departments/DepartmentsStore";

class Store {
  title = "";

  authStore = new AuthStore();
  customer = new CustomerStore();
  newAgent = new NewAgentStore();
  newUser = new NewUserStore();
  newCampaign = new NewCampaignStore();
  userStore = new UserStore();
  editAgent = new EditAgentStore();
  notificationStore = new NotificationStore();
  profileStore = new ProfileStore();
  // [DEPRECATED_GRAPHQL] - Para eliminación: ContactStore usa GraphQL queries
  // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
  
  // contactStore = new ContactStore();
  viewAgentStore = new ViewAgentStore();
  unifiedCustomerProfileStore = new UnifiedCustomerProfileStore();
  annUnifiedCustomerProfileStore = new AnnUnifiedCustomerProfileStore();
  agentsTeamsStore = new AgentsTeamsStore();
  agentStore = new AgentStore();
  agentTreeStore = new AgentTreeStore();
  conversationsStore = new ConversationsStore();
  viewConversationStore = new ViewConversationStore();
  conversationsActionsStore = new ConversationsActionsStore();
  selectedUserStore = new SelectedUserStore();
  listUserStore = new ListUserStore();
  listRoleStore = new ListRoleStore();
  historyAgentStore = new HistoryAgentStore();
  listGroupStore = new ListGroupStore();
  featureStore = new FeatureStore();
  permissionsSetupStore = new PermissionsSetupStore();
  blastCampaignStore = new BlastCampaignStore();
  contactSegmentStore = new ContactSegmentStore();
  humanInTheLoopStore = new HumanInTheLoopStore();
  assistanceUCPStore = new AssistanceUCPStore();
  marketingStore = new MarketingStore();
  // [DEPRECATED_GRAPHQL] - Para eliminación: AlertStore usa GraphQL queries
  // alertStore = new AlertStore();
  dataStore = new DataStore();
  questionsStore = new QuestionsStore();
  notesStore = new NotesStore();
  agentsWidgetHistoryStore = new AgentsWidgetHistoryStore();
  conversationListStore = new ConversationListStore();
  instructionsStore = new InstructionsStore();
  toolsStore = new ToolsStore();



  

  // Initialize base stores first
  agentListStore = new AgentListStore();
  vaultStore = new VaultStore();
  documentStore = new DocumentStore();
  fileStore = new FileStore();
  breadcrumbStore = new BreadcrumbStore();

  // Initialize dependent stores with injected dependencies
  playgroundAgentStore = new PlaygroundAgentStore(this.agentListStore);
  playgroundConfigStore = new PlaygroundConfigStore(this.playgroundAgentStore);
  knowledgeStore = new KnowledgeStore(this.playgroundAgentStore);
  
  // Drive general stores
  drivesStore = new DrivesStore();
  foldersStore = new FoldersStore();
  documentsStore = new DocumentsStore();
  filesStore = new FilesStore();
  agentsStore = new AgentsStore();
  resourcesStore = new ResourcesStore();
  usersStore = new UsersStore();
  workspaceStore = new WorkspaceStore();
  chatStore = ChatStore;
  departmentsStore = new DepartmentsStore();
  
  // Chat documents store (singleton instance)
  chatDocumentsStore = chatDocumentsStoreInstance;
 
	constructor() {
    makeObservable(this, {
      title: observable,
      authStore: observable,
      newAgent: observable,
      editAgent: observable,
      customer: observable,
      userStore: observable,
      notificationStore: observable,
      profileStore: observable,
      // [DEPRECATED_GRAPHQL] - Para eliminación: ContactStore usa GraphQL queries
      // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
      
      // contactStore: observable,
      viewAgentStore: observable,
      unifiedCustomerProfileStore: observable,
      changeTitle: action,
      agentsTeamsStore: observable,
      agentStore: observable,
      agentTreeStore: observable,
      viewConversationStore: observable,
      conversationsActionsStore: observable,
      conversationsStore: observable,
      selectedUserStore: observable,
      listUserStore: observable,
      listRoleStore: observable,
      historyAgentStore: observable,
      listGroupStore: observable,
      featureStore: observable,
      permissionsSetupStore: observable,
      contactSegmentStore: observable,
      assistanceUCPStore: observable,
      marketingStore: observable,
      // [DEPRECATED_GRAPHQL] - Para eliminación: AlertStore usa GraphQL queries
      // alertStore: observable,
      dataStore: observable,
      questionsStore: observable,
      notesStore: observable,
      agentsWidgetHistoryStore: observable,
      conversationListStore: observable,
      instructionsStore: observable,
      // Base stores
      agentListStore: observable,
      vaultStore: observable,
      documentStore: observable,
      fileStore: observable,
      breadcrumbStore: observable,

      // Dependent stores
      playgroundAgentStore: observable,
      playgroundConfigStore: observable,
      knowledgeStore: observable,
      
      // Drive general stores
      drivesStore: observable,
      foldersStore: observable,
      documentsStore: observable,
      filesStore: observable,
      agentsStore: observable,
      resourcesStore: observable,
      usersStore: observable,
      workspaceStore: observable,
      departmentsStore: observable,
      
      // Chat documents store
      chatDocumentsStore: observable,
    });
  }

  changeTitle = (title) => {
    this.title = title;
  };
  

  globalConstants = () => {
    return {
      userRoleGroups: ["superadmin", "customeradmin", "user"],
      onboardingTemplate: {
        isKeyReady: false,
        isCampaingReady: false,
        isChannelReady: false,
        isAssistantReady: false,
      },
    };
  };
}

const DefaultStore = new Store();
export default DefaultStore;
